import publishWarningModalUrl from './publishWarningModal.html';

class PublishWarningModalCtrl {
  constructor(Authentication, Utils, sdk) {
    'ngInject';

    Object.assign(this, { Authentication, Utils, sdk });

    this.notificationSupportEnabled = false; // coming in v2
    this.rangePickerEnabled = false; // coming in v2
    this.rememberWarningEnabled = false; // coming in v2
    this.doNotWarnAgain = false;
  }

  $onInit() {
    const { PUBLISH_SHIFT_WARNING_NOTIFICATION_TYPES } = this.sdk('constants');

    this.notificationTypes = [...PUBLISH_SHIFT_WARNING_NOTIFICATION_TYPES];
    this.notificationType = this.notificationTypes[0];

    this.uniqueEvents = this.Utils.uniq(this.events, (e) => e.id);
    this.totalShiftsCount = this.uniqueEvents.reduce(
      (count, event) => count + (event.slots || 1),
      0
    );
    const durationInMinutes = this.getTotalDurationInMinutes();
    const decimalFormat = this.Utils.getDecimalFormat();
    this.displayDuration = this.Utils.getDisplayDuration(durationInMinutes, decimalFormat);
  }

  selectNotificationType(notificationType) {
    this.notificationType = notificationType;
  }

  getTotalDurationInMinutes() {
    const { EVENT_STATUS, SHIFT_TYPE } = this.sdk('constants');
    return this.uniqueEvents.reduce((acc, event) => {
      if (event.type === SHIFT_TYPE && event.status === EVENT_STATUS.PLANNING) {
        return acc + event.paidDurationMinutes * (event.slots || 1);
      }
      return acc;
    }, 0);
  }

  publish() {
    this.close({
      notificationType: this.notificationType,
      doNotWarnAgain: this.doNotWarnAgain,
    });
  }
}

export default {
  templateUrl: publishWarningModalUrl,
  controller: PublishWarningModalCtrl,
  controllerAs: 'ctrl',
  bindings: {
    publishWarningSchema: '<',
    events: '<',
    rangeStart: '<',
    rangeEnd: '<',
    dismiss: '<',
    close: '<',
  },
};
